import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { site } from "../content/site";
import { Reveal } from "./Reveal";
import { SectionHeader } from "./SectionHeader";

export const Faq = () => (
  <section id="faqs" className="border-t border-gray-200 bg-white" data-testid="faq-section">
    <div className="mx-auto max-w-3xl px-4 py-20 sm:px-6 lg:px-8 lg:py-24">
      <SectionHeader eyebrow={site.faqs.eyebrow} heading={site.faqs.heading} testid="faq-heading" />
      <Reveal delay={0.1} className="mt-10">
        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {site.faqs.items.map((item, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="border-gray-200">
              <AccordionTrigger
                data-testid={`faq-question-${i}`}
                className="py-5 text-left font-heading text-base font-semibold text-gray-900 hover:no-underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-brand"
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent data-testid={`faq-answer-${i}`} className="text-sm leading-relaxed text-gray-600">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
